import { Sparkles } from "lucide-react";

/**
 * Small "Uskoro" chip. NEVER renders alone — always accompanied by the
 * activation sentence (rule: no bare "Uskoro"). Callers must render the
 * sentence next to this chip.
 */
export function UskoroBadge({ testid }) {
  return (
    <span
      data-testid={testid || "uskoro-badge"}
      className="inline-flex items-center gap-1 text-[10px] uppercase tracking-wider font-medium px-1.5 py-0.5 rounded border bg-surface-secondary border-line text-ink-muted"
    >
      Uskoro
    </span>
  );
}

/**
 * Full sleeping row indicator — badge + activation sentence side-by-side.
 * Calm styling, no danger/warning color (sleeping is not a problem, it's
 * work saved for later).
 */
export function SleepingIndicator({ sentence, testid }) {
  return (
    <div
      data-testid={testid || "sleeping-indicator"}
      className="flex items-start gap-1.5 flex-wrap min-w-0 text-[11px] text-ink-muted"
    >
      <UskoroBadge />
      {sentence && (
        <span className="leading-snug break-words">{sentence}</span>
      )}
    </div>
  );
}

/**
 * Freshly-activated indicator: shown up to 24h after activated_at is set.
 */
export function FreshlyActivatedIndicator({ testid }) {
  return (
    <span
      data-testid={testid || "freshly-activated"}
      className="inline-flex items-center gap-1 text-[11px] text-forest font-medium"
    >
      <Sparkles className="w-3 h-3" aria-hidden /> Upravo se otvorilo
    </span>
  );
}
